import { Text, Flex, Button, chakra, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";

function Rules() {
  return (
    <Flex 
        flexDir={["column-reverse","column-reverse","column-reverse","row","row"]}
        width="100vw" 
        minHeight="100vh"
        bg="#171717"
        justifyContent="space-around"
        alignItems="flex-start"
    >
        <Flex 
            flexDir="column" 
            width={["80vw","80vw","80vw","600px","600px"]}
            m="30px"
        >
            <Text 
                color="core.white" 
                fontSize={["32px","32px","32px","48px","48px"]}
                fontWeight="800"
                lineHeight="1"
                mb="20px"
            >
                <chakra.span color="core.red">Rules </chakra.span>
                <chakra.span color="core.white">and </chakra.span>
                <chakra.span color="core.red">Regulations </chakra.span>
            </Text>
            <Text 
                color="core.white" 
                fontSize="16px" 
                fontWeight="500"
                mt="20px"
                mb="20px"
            >
                <ol>
                    <li>
                        To access the quiz, you need to first click on “Start Quiz” and then Log in with your credentials.
                    </li>
                    <br></br>
                    <li>
                        Your credentials would be:
                        <br></br>
                        <strong>Email Address -</strong> The registered email 
                        <br></br>
                        <strong>Password -</strong> The OTP received on the registered email ID on the day of the quiz.
                    </li>
                    <br></br>
                    <li>
                        Once the quiz starts, the player will get 20 seconds each to answer the 40 direct economics/finance/GK questions, accounting to a total of 13 minutes and 20 seconds.
                    </li>
                    <br></br>
                    <li>
                        Marking ~ Every participant will be ranked on accuracy (score) and speed (time of last question answered).
                    </li>
                    <br></br>
                    <li>
                        4 points would be given for every right answer, and 0.1 point deducted for every additional second taken.
                    </li>
                    <br></br>
                    <li>
                        0 marks for wrong answers, and no negative marking.
                    </li>
                    <br></br>
                    <li>
                        After the quiz ends, a leaderboard would go live on the EOTY website at 7 p.m. (IST) on the day of the quiz i.e. 15th March 2022, where the top 50 participants would qualify for the second round. 
                    </li>
                </ol>

            All the best!!          
            </Text>
            <Flex flexDir="row" mt="20px">
                <Link to="/">
                    <Button 
                        fontWeight="800" 
                        mr="24px"
                        bg="core.white"
                        color="core.dg"
                        size="lg"
                    >BACK TO HOME</Button>
                </Link>
            </Flex>
        </Flex>


        <Flex 
            flexDir="column" 
            width={["80vw","80vw","80vw","600px","600px"]}
            minHeight={["300px","300px","300px","90vh","90vh"]}
            bg="#FF6B6B" 
            m="30px"
            borderRadius="25px"
        >
            <Image margin="auto" src="https://i.imgur.com/eroDeRP.png" width="80%" />
        </Flex>
    </Flex>
  );
}

export default Rules;
